/**
 * ABテスト設定オブジェクト
 * @typedef {Object} ABTestConfig
 * @property {string} testName - テスト名
 * @property {number} bPatternRatio - Bパターンの割合（0-100）
 * @property {boolean} enable - ABテストを有効にするかどうか
 */

// フッタータブABテストの定義
export const FOOTER_TAB_AB_TEST_NAME = 'FOOTER_TAB_AB_TEST'
export const SEARCH_AND_EVENT_DETAIL_AB_TEST_NAME = 'SEARCH_AND_EVENT_DETAIL'
export const SEARCH_PAGE_RECOMMEND_ORDER_LOGIC_AB_TEST_NAME = 'SEARCH_PAGE_RECOMMEND_ORDER_LOGIC'
export const TOP_FV_V3_AB_TEST_NAME = 'TOP_FV_V3_AB_TEST'

/**
 * フッタータブABテスト設定
 * @type {ABTestConfig}
 */
export const FOOTER_TAB_AB_TEST_CONFIG = {
  testName: FOOTER_TAB_AB_TEST_NAME,
  bPatternRatio: 30, // 30% B pattern (非表示), 70% A pattern (表示)
  enable: false
}

export const SEARCH_AND_EVENT_DETAIL_AB_TEST_CONFIG = {
  testName: SEARCH_AND_EVENT_DETAIL_AB_TEST_NAME,
  bPatternRatio: 20,
  enable: false
}

export const EVENT_TITLE_AB_TEST_NAME = 'EVENT_TITLE_AB_TEST'

/**
 * イベントタイトルABテスト設定
 * @type {ABTestConfig}
 */
export const EVENT_TITLE_AB_TEST_CONFIG = {
  testName: EVENT_TITLE_AB_TEST_NAME,
  bPatternRatio: 50, // 50% B pattern (短いタイトル), 50% A pattern (長いタイトル)
  enable: false
}
export const SEARCH_PAGE_RECOMMEND_ORDER_LOGIC_AB_TEST_CONFIG = {
  testName: SEARCH_PAGE_RECOMMEND_ORDER_LOGIC_AB_TEST_NAME,
  bPatternRatio: 30,
  enable: true
}

export const TOP_FV_V3_AB_TEST_CONFIG = {
  testName: TOP_FV_V3_AB_TEST_NAME,
  bPatternRatio: 30, // 30% Bパターン（新機能適用）
  enable: false // テスト有効
}

export const CLS_MONITORING_AB_TEST_NAME = 'CLS_MONITORING_TEST'
export const CLS_MONITORING_AB_TEST_CONFIG = {
  testName: CLS_MONITORING_AB_TEST_NAME,
  bPatternRatio: 10, // 10% B pattern (monitoring enabled)
  enable: true
}
